import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Theme,
  Tooltip,
  createStyles,
} from "@mui/material";
import { DrawerContainer } from "../../shared/drawer/DrawerContainer";
import { makeStyles } from "@mui/styles";
import { useEffect, useState } from "react";
import {
  DescriptionTwoTone,
  Visibility,
  VisibilityOff,
  ContentCopy,
} from "@mui/icons-material";
import { commonStyles } from "../../shared/styles/commonStyles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Dayjs } from "dayjs";
import { useLocation } from "react-router-dom";
import { ISolaceConsumer } from "../../../solace-pub-sub/types/ISolaceConsumer";
import { InitializeQueueBrowser } from "../../../solace-pub-sub/initializeQueueBrowser";
import { useSelector, useDispatch } from "react-redux";
import { allPriceListInfoSelector } from "../../../redux/selectors/getPricingInfoSelector";
import { format } from "date-fns";
import { storeSolaceCredentialSelector } from "../../../redux/selectors/storeSolaceCredentialSelector";
import { SOLACE_PRICEING_DATA } from "../../../redux/actions/getPricingInfoActions";
import { SOLACE_CONSUME_EVENTS_SUCCESS } from "../../../redux/actions/consumeSolaceEventsActions";
import { STORE_PUBLISH_FIELD_DETAILS } from "../../../redux/actions/storePublishFieldDetailsActions";
import { getPublishFieldDetailSelector } from "../../../redux/selectors/getPublishFieldDetailSelector";
import { allSubscribePriceScreenSelector } from "../../../redux/selectors/getSubscribePriceScreenSelector";
import { GET_SUBSCRIBE_PRICE_SCREEN_DATA } from '../../../redux/actions/getSubscribePriceScreenActions';
import moment from "moment";
import barcodeImage from '../../../barcodeimg.png';
import { getPublishFieldDetail2Selector } from "../../../redux/selectors/getPublishFieldDetail2Selector";
import { STORE_PUBLISH_FIELD_DETAILS_2 } from "../../../redux/actions/storePublishFieldDetails2Actions";

const useStyles: any = makeStyles((theme: Theme) => ({
  // root: {
  //   margin: 0,
  // },
  mainContainer: {
    boxSizing: "border-box",
    width: "100%",
    padding: "0 0 0 65px",
    height: "100%",
  },
  table: {
    minWidth: 650,
    // minHeight: 500,
    maxHeight: 300,
    marginTop: "0.9rem",
  },
  emptyRowMessage: {
    margin: "0 auto",
    padding: "2rem",
  },
  buttons: {
    // width: '8%',
    color: "black",
    borderRadius: "5px",
    background: "#b9b9b9",
    textTransform: "none",
    fontSize: "20px",
    "&:hover": {
      background: "#787878",
    },
    height: "3.2rem",
  },
  input: {
    color: "#000000",
    // width: 200,
    height: 50,
    width: "100%",
  },
  inputHalfWidth: {
    width: "100%",
    "& .MuiAutocomplete-inputRoot": {
      height: 50,
    },
    margin: "10px 0 !important",
  },
  cardSubForm: {
    "& .MuiCardHeader-root": {
      paddingBottom: "0",
    },
    "& .MuiCardContent-root": {
      padding: "16px",
    },
  },
  buttonConfig: {
    margin: "2rem 0 !important",
  },
  dbIcon: {
    width: "25px",
    height: "25px",
  },
  mainSubscriber: {},
  subscriberPrice: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '24px',
  },
  subscriberPriceBox: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 0',
    width: 0,
    minWidth: '320px',
    background: '#fff',
    borderRadius: '12px',
    boxShadow: '0 2px 16px rgba(0,0,0,0.08)',
    overflow: 'hidden',
    border: '1px solid #e8e8e8',
  },
  subscriberPriceHeader: {
    fontSize: '12px',
    fontWeight: '700',
    letterSpacing: '2px',
    color: 'white',
    background: '#00844c',
    padding: '10px 16px',
  },
  subscriberPriceContent: {
    padding: '16px',
    borderBottom: '1px solid #f0f0f0',
  },
  subscriberPriceInfo: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '12px',
  },
  subScribeTable: {
    margin: "1.5rem",
  },
  addSubscriberTopic: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    marginBottom: '1rem',
    "& button": {
      marginLeft: "1rem",
    },
  },
}));

export const PricingComponent = (props: any) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const commonStyle: any = commonStyles();
  const { pathname } = useLocation();
  const allPriceListInfo: any = useSelector(allPriceListInfoSelector);
  const storeSolaceCredentials = useSelector(storeSolaceCredentialSelector);
  const fieldDetail = useSelector(getPublishFieldDetailSelector);
  const fieldDetail2 = useSelector(getPublishFieldDetail2Selector);
  const subscribeScreenScreenInfo = useSelector(allSubscribePriceScreenSelector);
  const [userType, setUserType] = useState("");
  const [initalTopicFormat, _] = useState("scm");
  const [topicName, setTopicName] = useState<string>("acme/retail/shopfloor/price/updated/v1/uk/emea/51001");
  const [topicName2, setTopicName2] = useState<string>("acme/retail/shopfloor/price/updated/v1/uk/emea/51002");
  const [numberOfTopicSubscribers, setNumberOfTopicSubscribers] = useState([
    {
      id: 1,
      topic: "",
      topicData: [],
      page: 0,
      rowsPerPage: 25,
      pageOffset: 0,
    },
    {
      id: 2,
      topic: "",
      topicData: [],
      page: 0,
      rowsPerPage: 25,
      pageOffset: 0,
    },
    {
      id: 3,
      topic: "",
      topicData: [],
      page: 0,
      rowsPerPage: 25,
      pageOffset: 0,
    },
  ]);

  const handleFormChange = (fieldName: string, e: any, value?: any) => {
    dispatch({
      type: STORE_PUBLISH_FIELD_DETAILS,
      payload: { key: fieldName, value: encodeURIComponent(e.target.value) },
    });
  };

  const handleFormChange2 = (fieldName: string, e: any, value?: any) => {
    dispatch({
      type: STORE_PUBLISH_FIELD_DETAILS_2,
      payload: { key: fieldName, value: encodeURIComponent(e.target.value) },
    });
  };

  const handleAddBroker = (e: any) => {
    if (
      fieldDetail &&
      fieldDetail["product_id"] &&
      fieldDetail["region"] &&
      fieldDetail["pricing"] &&
      storeSolaceCredentials &&
      storeSolaceCredentials["host"] &&
      storeSolaceCredentials["messageVpn"] &&
      topicName
    ) {
      let initialize = new InitializeQueueBrowser();
      let topic: string = getTopicStructure();
      let solaceEvents: ISolaceConsumer = initialize.init(
        topic,
        storeSolaceCredentials,
        JSON.stringify({ ...fieldDetail, date: moment().format('DD-MM-YYYY HH:mm:ss') })
      );
    }
  };

  const handleAddBroker2 = (e: any) => {
    if (
      fieldDetail2 &&
      fieldDetail2["product_id"] &&
      fieldDetail2["region"] &&
      fieldDetail2["pricing"] &&
      storeSolaceCredentials &&
      storeSolaceCredentials["host"] &&
      storeSolaceCredentials["messageVpn"] &&
      topicName2
    ) {
      let initialize = new InitializeQueueBrowser();
      let topic: string = getTopicStructure2();
      let solaceEvents: ISolaceConsumer = initialize.init(
        topic,
        storeSolaceCredentials,
        JSON.stringify({ ...fieldDetail2, date: moment().format('DD-MM-YYYY HH:mm:ss') })
      );
    }
  };

  useEffect(() => {
    setUserType(
      pathname.includes("/pricesubscriber") || pathname.includes("/pricetags")
        ? "subscriber"
        : pathname.includes("/pricepublisher")
          ? "publisher"
          : ""
    );
  }, [pathname]);

  useEffect(() => {
    setNumberOfTopicSubscribers(allPriceListInfo);
  }, [allPriceListInfo]);

  // triggered when user clicks on next page
  const handleChangePage = (
    event: unknown,
    newPage: number,
    topicId: number
  ) => {
    let updatedNumberOfTopicSubscribers = allPriceListInfo.map((tEl: any) => {
      if (tEl["id"] === topicId) {
        return { ...tEl, page: newPage };
      }
      return tEl;
    });
    let topicData: any = updatedNumberOfTopicSubscribers.filter(
      (tEl: { id: number; topic: string; topicData: any }) =>
        tEl["id"] === topicId
    );
    topicData = topicData && topicData[0];

    const offset: number =
      newPage < topicData["page"]
        ? topicData["pageOffset"] - topicData["rowsPerPage"]
        : topicData["rowsPerPage"] + topicData["pageOffset"];

    updatedNumberOfTopicSubscribers = updatedNumberOfTopicSubscribers.map(
      (tEl: any) => {
        if (tEl["id"] === topicId) {
          return { ...tEl, pageOffset: offset };
        }
        return tEl;
      }
    );

    setNumberOfTopicSubscribers(updatedNumberOfTopicSubscribers);
  };

  // triggered when user changes the number of rows per page
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
    topicId: number
  ) => {
    let updatedNumberOfTopicSubscribers = allPriceListInfo.map((tEl: any) => {
      if (tEl["id"] === topicId) {
        return {
          ...tEl,
          rowsPerPage: parseInt(event.target.value, 10),
          page: 0,
          pageOffset: 0,
        };
      }
      return tEl;
    });
    setNumberOfTopicSubscribers(updatedNumberOfTopicSubscribers);
  };

  const handleChangeTopic = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    topicId: number
  ) => {
    setTopicName(event.target.value);
    let updatedAllTopicSubscribers = allPriceListInfo.map(
      (tEl: { id: number; topic: string; topicData: any }) => {
        if (tEl["id"] === topicId) {
          return { ...tEl, topic: event.target.value };
        }
        return tEl;
      }
    );
    props.setSubComs((prevSubComs: any) => {
      const updatedSubComs = prevSubComs.map((subCom: any) => {
        if (subCom.id === topicId) {
          return { ...subCom, topic: event.target.value };
        }
        return subCom;
      });

      return updatedSubComs;
    });
    dispatch({
      type: SOLACE_PRICEING_DATA,
      payload: updatedAllTopicSubscribers,
    });

  };

  const handleSubscribeTopic = (topicId: number) => {
    if (
      pathname.includes("/pricesubscriber") &&
      storeSolaceCredentials &&
      storeSolaceCredentials["host"] &&
      storeSolaceCredentials["messageVpn"]
    ) {
      let updatedAllTopicSubscribers = allPriceListInfo.map(
        (tEl: { id: number; topic: string; topicData: any }) => {
          if (tEl["id"] === topicId) {
            return { ...tEl, topicData: [] };
          }
          return tEl;
        }
      );
      dispatch({
        type: SOLACE_PRICEING_DATA,
        payload: updatedAllTopicSubscribers,
      });

      let initialize = new InitializeQueueBrowser();
      let topic: any = updatedAllTopicSubscribers.filter(
        (tEl: { id: number; topic: string; topicData: any }) =>
          tEl["id"] === topicId
      );
      topic = topic && topic[0] && topic[0]["topic"];
      if (topic) {
        let solaceEvents: ISolaceConsumer = initialize.init(
          topic,
          storeSolaceCredentials,
          null
        );
      }
    }
  };

  const getTopicStructure = (): string => {
    let updatedTopicObject = {};
    let topic: string = "";
    if (topicName) {
      Object.keys(fieldDetail).forEach((field: string) => {
        updatedTopicObject["{" + field + "}"] = fieldDetail[field];
      });
      let topicObjFlatten = topicName.split("/").join("|");
      const pattern = new RegExp(topicObjFlatten, "gi");

      topic = topicObjFlatten
        .replace(pattern, (matched: any) => {
          return updatedTopicObject[matched]
            ? updatedTopicObject[matched]
            : matched;
        })
        .split("|")
        .join("/");
    }
    return topic;
  };
  const getTopicStructure2 = (): string => {
    let updatedTopicObject = {};
    let topic: string = "";
    if (topicName2) {
      Object.keys(fieldDetail2).forEach((field: string) => {
        updatedTopicObject["{" + field + "}"] = fieldDetail[field];
      });
      let topicObjFlatten = topicName2.split("/").join("|");
      const pattern = new RegExp(topicObjFlatten, "gi");

      topic = topicObjFlatten
        .replace(pattern, (matched: any) => {
          return updatedTopicObject[matched]
            ? updatedTopicObject[matched]
            : matched;
        })
        .split("|")
        .join("/");
    }
    return topic;
  };

  const handleChangeSubscribePriceScreenTopic = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    topicId: string) => {

    let updatedAllTopicSubscribers = subscribeScreenScreenInfo.map(
      (tEl: { id: string; topic: string; topicData: any }) => {
        if (tEl["id"] === topicId) {
          return { ...tEl, topic: event.target.value };
        }
        return tEl;
      }
    );

    props.setSubscribePriceScreenData((prevSubComs: any) => {
      const updatedSubComs = prevSubComs.map((subCom: any) => {
        if (subCom.id === topicId) {
          return { ...subCom, topic: event.target.value };
        }
        return subCom;
      });

      return updatedSubComs;
    });

    dispatch({
      type: GET_SUBSCRIBE_PRICE_SCREEN_DATA,
      payload: updatedAllTopicSubscribers,
    });

  };
  const handleSubscribePriceScreenTopic = (topicId: string) => {
    if (
      pathname.includes("/pricetags") &&
      storeSolaceCredentials &&
      storeSolaceCredentials["host"] &&
      storeSolaceCredentials["messageVpn"]
    ) {
      let updatedAllTopicSubscribers = subscribeScreenScreenInfo.map(
        (tEl: { id: string; topic: string; topicData: any }) => {
          if (tEl["id"] === topicId) {
            return { ...tEl, topicData: [] };
          }
          return tEl;
        }
      );
      dispatch({
        type: GET_SUBSCRIBE_PRICE_SCREEN_DATA,
        payload: updatedAllTopicSubscribers,
      });

      let initialize = new InitializeQueueBrowser();
      let topic: any = updatedAllTopicSubscribers.filter(
        (tEl: { id: string; topic: string; topicData: any }) =>
          tEl["id"] === topicId
      );
      topic = topic && topic[0] && topic[0]["topic"];
      if (topic) {
        let solaceEvents: ISolaceConsumer = initialize.init(
          topic,
          storeSolaceCredentials,
          null
        );
      }
    }
  }
  const getSubscirbePriceScreenTopicInfo = (topicId: string): any => {
    let topicInfo = subscribeScreenScreenInfo.filter((t: any) => t['id'] === topicId);
    return topicInfo ? topicInfo[0] : null
  };

  const getSubscribeScreenPriceFormat = (topicId:string)=>{
    let currency = getSubscirbePriceScreenTopicInfo(topicId)?.['topicData']?.['currency'];
    let pricing = getSubscirbePriceScreenTopicInfo(topicId)?.['topicData']?.['pricing'];
    return currency&&pricing ? `${currency} ${pricing}` : null;
  }
  const componentBasedOnPath = () => {
    if (pathname.includes("/pricepublisher")) {
      return (
        <div style={{
          display: 'flex'
        }}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
          style={{
            padding: "0 20px",
            display: "flex",
            flexDirection: "column",
            width: '50%'
          }}
        >
          <TextField
            label={"country"}
            name={"country"}
            placeholder={"country"}
            type="text"
            value={
              fieldDetail["country"] && fieldDetail["country"]
                ? decodeURIComponent(fieldDetail["country"])
                : ""
            }
            onChange={(e: any) => {
              handleFormChange("country", e);
            }}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input,
            }}
            variant="outlined"
            required={true}
          />
          <TextField
            label={"region"}
            name={"region"}
            placeholder={"region"}
            type="text"
            value={
              fieldDetail["region"] && fieldDetail["region"]
                ? decodeURIComponent(fieldDetail["region"])
                : ""
            }
            onChange={(e: any) => {
              handleFormChange("region", e);
            }}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input,
            }}
            variant="outlined"
            required={true}
          />
          <TextField
            label={"province"}
            name={"province"}
            placeholder={"province"}
            type="text"
            value={
              fieldDetail["province"] && fieldDetail["province"]
                ? decodeURIComponent(fieldDetail["province"])
                : ""
            }
            onChange={(e: any) => {
              handleFormChange("province", e);
            }}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input,
            }}
            variant="outlined"
          />
          <TextField
            label={"product_id"}
            name={"product_id"}
            placeholder={"product_id"}
            type="text"
            value={
              fieldDetail["product_id"] && fieldDetail["product_id"]
                ? decodeURIComponent(fieldDetail["product_id"])
                : ""
            }
            onChange={(e: any) => {
              handleFormChange("product_id", e);
            }}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input,
            }}
            variant="outlined"
            required={true}
          />
          <TextField
            label={"product_description"}
            name={"product_description"}
            placeholder={"product_description"}
            type="text"
            value={
              fieldDetail["product_description"] &&
                fieldDetail["product_description"]
                ? decodeURIComponent(fieldDetail["product_description"])
                : ""
            }
            onChange={(e: any) => {
              handleFormChange("product_description", e);
            }}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input,
            }}
            variant="outlined"
            required={true}
          />
          <TextField
            label={"currency"}
            name={"currency"}
            placeholder={"currency"}
            type="text"
            value={
              fieldDetail["currency"] && fieldDetail["currency"]
                ? decodeURIComponent(fieldDetail["currency"])
                : ""
            }
            onChange={(e: any) => {
              handleFormChange("currency", e);
            }}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input
            }}
            variant="outlined"
            required={true}
          />
          <TextField
            label={"pricing"}
            name={"pricing"}
            placeholder={"pricing"}
            type="text"
            value={
              fieldDetail["pricing"] && fieldDetail["pricing"]
                ? decodeURIComponent(fieldDetail["pricing"])
                : ""
            }
            onChange={(e: any) => {
              handleFormChange("pricing", e);
            }}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input,
              type: "number",
            }}
            variant="outlined"
            required={true}
          />
          <TextField
            label={"origin"}
            name={"origin"}
            placeholder={"origin"}
            type="text"
            value={
              fieldDetail["origin"] && fieldDetail["origin"]
                ? decodeURIComponent(fieldDetail["origin"])
                : ""
            }
            onChange={(e: any) => {
              handleFormChange("origin", e);
            }}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input,
            }}
            variant="outlined"
            required={true}
          />
          <TextField
            label={"specification"}
            name={"specification"}
            placeholder={"specification"}
            type="text"
            value={
              fieldDetail["specification"] && fieldDetail["specification"]
                ? decodeURIComponent(fieldDetail["specification"])
                : ""
            }
            onChange={(e: any) => {
              handleFormChange("specification", e);
            }}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input,
            }}
            variant="outlined"
            required={true}
          />
          {/* <div
          className={
            classes.inputHalfWidth
          }
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}
          >
            <DatePicker value={date} onChange={(newValue) => {
              const selectedDateObj: any = newValue ? newValue.toDate() : null; // Convert Dayjs to Date
              const formattedDate = newValue
                ? format(selectedDateObj, "dd/MM/yyyy")
                : "";

              handleFormChange('date', null, formattedDate)
              setDate(newValue)
            }}
            />
          </LocalizationProvider>
        </div> */}

          <TextField
            label={"Topic Structure"}
            name={"Topic Structure"}
            placeholder={"Topic Structure"}
            type="text"
            value={topicName}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input,
            }}
            helperText={'Example Topic:acme/retail/shopfloor/price/update/{country}/{region}/{product_id})'}
            onChange={(
              event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            ) => setTopicName(event.target.value)}
            variant="outlined"
            required={true}
          />

          <div>
            <Button
              type="submit"
              onClick={(e) => {
                handleAddBroker(e);
              }}
              variant="contained"
              color="primary"
              size="large"
              disabled={false}
              className={classes.buttonConfig}
              endIcon={
                false ? (
                  <CircularProgress
                    style={{
                      color: "white",
                      height: "23px",
                      width: "23px",
                      margin: "0 6px 0 0",
                    }}
                  />
                ) : (
                  ""
                )
              }
            >
              Add Pricing
            </Button>
          </div>
        </form>
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
          style={{
            padding: "0 20px",
            display: "flex",
            flexDirection: "column",
            width: '50%'
          }}
        >
          <TextField
            label={"country"}
            name={"country"}
            placeholder={"country"}
            type="text"
            value={
              fieldDetail2["country"] && fieldDetail2["country"]
                ? decodeURIComponent(fieldDetail2["country"])
                : ""
            }
            onChange={(e: any) => {
              handleFormChange2("country", e);
            }}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input,
            }}
            variant="outlined"
            required={true}
          />
          <TextField
            label={"region"}
            name={"region"}
            placeholder={"region"}
            type="text"
            value={
              fieldDetail2["region"] && fieldDetail2["region"]
                ? decodeURIComponent(fieldDetail2["region"])
                : ""
            }
            onChange={(e: any) => {
              handleFormChange2("region", e);
            }}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input,
            }}
            variant="outlined"
            required={true}
          />
          <TextField
            label={"province"}
            name={"province"}
            placeholder={"province"}
            type="text"
            value={
              fieldDetail2["province"] && fieldDetail2["province"]
                ? decodeURIComponent(fieldDetail2["province"])
                : ""
            }
            onChange={(e: any) => {
              handleFormChange2("province", e);
            }}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input,
            }}
            variant="outlined"
          />
          <TextField
            label={"product_id"}
            name={"product_id"}
            placeholder={"product_id"}
            type="text"
            value={
              fieldDetail2["product_id"] && fieldDetail2["product_id"]
                ? decodeURIComponent(fieldDetail2["product_id"])
                : ""
            }
            onChange={(e: any) => {
              handleFormChange2("product_id", e);
            }}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input,
            }}
            variant="outlined"
            required={true}
          />
          <TextField
            label={"product_description"}
            name={"product_description"}
            placeholder={"product_description"}
            type="text"
            value={
              fieldDetail2["product_description"] &&
                fieldDetail2["product_description"]
                ? decodeURIComponent(fieldDetail2["product_description"])
                : ""
            }
            onChange={(e: any) => {
              handleFormChange2("product_description", e);
            }}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input,
            }}
            variant="outlined"
            required={true}
          />
            <TextField
            label={"currency"}
            name={"currency"}
            placeholder={"currency"}
            type="text"
            value={
              fieldDetail2["currency"] && fieldDetail2["currency"]
                ? decodeURIComponent(fieldDetail2["currency"])
                : ""
            }
            onChange={(e: any) => {
              handleFormChange2("currency", e);
            }}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input
            }}
            variant="outlined"
            required={true}
          />
          <TextField
            label={"pricing"}
            name={"pricing"}
            placeholder={"pricing"}
            type="text"
            value={
              fieldDetail2["pricing"] && fieldDetail2["pricing"]
                ? decodeURIComponent(fieldDetail2["pricing"])
                : ""
            }
            onChange={(e: any) => {
              handleFormChange2("pricing", e);
            }}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input,
              type: "number",
            }}
            variant="outlined"
            required={true}
          />
          <TextField
            label={"origin"}
            name={"origin"}
            placeholder={"origin"}
            type="text"
            value={
              fieldDetail2["origin"] && fieldDetail2["origin"]
                ? decodeURIComponent(fieldDetail2["origin"])
                : ""
            }
            onChange={(e: any) => {
              handleFormChange2("origin", e);
            }}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input,
            }}
            variant="outlined"
            required={true}
          />
          <TextField
            label={"specification"}
            name={"specification"}
            placeholder={"specification"}
            type="text"
            value={
              fieldDetail2["specification"] && fieldDetail2["specification"]
                ? decodeURIComponent(fieldDetail2["specification"])
                : ""
            }
            onChange={(e: any) => {
              handleFormChange2("specification", e);
            }}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input,
            }}
            variant="outlined"
            required={true}
          />
          {/* <div
          className={
            classes.inputHalfWidth
          }
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}
          >
            <DatePicker value={date} onChange={(newValue) => {
              const selectedDateObj: any = newValue ? newValue.toDate() : null; // Convert Dayjs to Date
              const formattedDate = newValue
                ? format(selectedDateObj, "dd/MM/yyyy")
                : "";

              handleFormChange('date', null, formattedDate)
              setDate(newValue)
            }}
            />
          </LocalizationProvider>
        </div> */}

          <TextField
            label={"Topic Structure"}
            name={"Topic Structure"}
            placeholder={"Topic Structure"}
            type="text"
            value={topicName2}
            className={classes.inputHalfWidth}
            InputProps={{
              className: classes.input,
            }}
            helperText={'Example Topic:acme/retail/shopfloor/price/update/{country}/{region}/{product_id})'}
            onChange={(
              event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            ) => setTopicName2(event.target.value)}
            variant="outlined"
            required={true}
          />

          <div>
            <Button
              type="submit"
              onClick={(e) => {
                handleAddBroker2(e);
              }}
              variant="contained"
              color="primary"
              size="large"
              disabled={false}
              className={classes.buttonConfig}
              endIcon={
                false ? (
                  <CircularProgress
                    style={{
                      color: "white",
                      height: "23px",
                      width: "23px",
                      margin: "0 6px 0 0",
                    }}
                  />
                ) : (
                  ""
                )
              }
            >
              Add Pricing
            </Button>
          </div>
        </form>
        </div>
      )
    }
    if (pathname.includes("/pricetags")) {
      return (<div
        style={{
          padding: "0 20px",
          zoom: 0.8,
        }}
      >
        <div className={classes.subscriberPrice}>
          <div className={classes.subscriberPriceBox}>
            <div className={classes.subscriberPriceHeader}>North America</div>

            <div className={classes.subscriberPriceContent}>
              <div className={classes.addSubscriberTopic}>
                <TextField
                  id="outlined-error-helper-text"
                  label="Topic"
                  value={(() => {
                    let topicInfo = props.subscribePriceScreenData.filter((t: any) => t['id'] === 'NORTH_AMERICA_BELGIAN_COCHOLATE')[0];
                    return topicInfo['topic'] ? topicInfo['topic'] : ''
                  })()}
                  onChange={(
                    event: React.ChangeEvent<
                      HTMLInputElement | HTMLTextAreaElement
                    >
                  ) => handleChangeSubscribePriceScreenTopic(event, 'NORTH_AMERICA_BELGIAN_COCHOLATE')}
                // helperText="seperated by '/'e.g:'test/v1'"
                />
                <Button
                  style={{
                    border: '2px black solid'
                  }}
                  variant="contained"
                  onClick={() => handleSubscribePriceScreenTopic('NORTH_AMERICA_BELGIAN_COCHOLATE')}
                  disabled={
                     getSubscirbePriceScreenTopicInfo('NORTH_AMERICA_BELGIAN_COCHOLATE')?.['topic'].length > 0
                      ? false
                      : true
                  }
                >
                  Subscribe
                </Button>
              </div>
              <div className={classes.subscriberPriceInfo}>
                <div style={{ width: '100%', borderRadius: '8px', overflow: 'hidden', border: '1px solid #e0e0e0', boxShadow: '0 2px 12px rgba(0,0,0,0.08)', fontFamily: 'Rubik, sans-serif' }}>
                  <div style={{ background: '#1C2742', padding: '10px 14px', color: '#fff', fontSize: '14px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    {getSubscirbePriceScreenTopicInfo('NORTH_AMERICA_BELGIAN_COCHOLATE')?.['topicData']?.['product_description'] ?? 'Milk Chocolate'}
                  </div>
                  <div style={{ background: '#FEFDF0', padding: '12px 14px' }}>
                    <div style={{ fontSize: '10px', color: '#888', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '2px' }}>Origin</div>
                    <div style={{ fontSize: '13px', color: '#333', fontWeight: '500', marginBottom: '8px' }}>
                      {getSubscirbePriceScreenTopicInfo('NORTH_AMERICA_BELGIAN_COCHOLATE')?.['topicData']?.['origin'] ?? 'Belgium'}
                    </div>
                    <div style={{ fontSize: '11px', color: '#666', lineHeight: '1.5', marginBottom: '14px', minHeight: '48px' }}>
                      {getSubscirbePriceScreenTopicInfo('NORTH_AMERICA_BELGIAN_COCHOLATE')?.['topicData']?.['specification'] ?? 'Assorted Belgian Milk Chocolate Truffles. 300g'}
                    </div>
                    <div style={{ fontSize: '30px', fontWeight: '900', fontFamily: "'Impact', 'Arial Black', sans-serif", color: '#c0392b', letterSpacing: '-1px' }}>
                      {getSubscribeScreenPriceFormat('NORTH_AMERICA_BELGIAN_COCHOLATE') ?? '—'}
                    </div>
                  </div>
                  <div style={{ background: '#f8f8f8', borderTop: '1px solid #eee', padding: '8px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: '10px', fontFamily: 'monospace', color: '#888', letterSpacing: '1px' }}>
                      {getSubscirbePriceScreenTopicInfo('NORTH_AMERICA_BELGIAN_COCHOLATE')?.['topicData']?.['product_id'] ?? '002335'}
                    </span>
                    <img src={barcodeImage} style={{ width: '80px', height: '26px', objectFit: 'fill', opacity: 0.7 }} alt="" />
                  </div>
                </div>
              </div>
            </div>


            <div className={classes.subscriberPriceContent}>
              <div className={classes.addSubscriberTopic}>
                <TextField
                  id="outlined-error-helper-text"
                  label="Topic"
                  value={(() => {
                    let topicInfo = props.subscribePriceScreenData?.filter((t: any) => t['id'] === 'NORTH_AMERICA_APPLE')?.[0];
                    return topicInfo?.['topic'] ? topicInfo?.['topic'] : ''
                  })()}
                  onChange={(
                    event: React.ChangeEvent<
                      HTMLInputElement | HTMLTextAreaElement
                    >
                  ) => handleChangeSubscribePriceScreenTopic(event, 'NORTH_AMERICA_APPLE')}
                // helperText="seperated by '/'e.g:'test/v1'"
                />
                <Button
                  style={{
                    border: '2px black solid'
                  }}
                  variant="contained"
                  onClick={() => handleSubscribePriceScreenTopic('NORTH_AMERICA_APPLE')}
                  disabled={
                    getSubscirbePriceScreenTopicInfo('NORTH_AMERICA_APPLE')?.['topic'].length > 0
                      ? false
                      : true
                  }
                >
                  Subscribe
                </Button>
              </div>
              <div className={classes.subscriberPriceInfo}>
                <div style={{ width: '100%', borderRadius: '8px', overflow: 'hidden', border: '1px solid #e0e0e0', boxShadow: '0 2px 12px rgba(0,0,0,0.08)', fontFamily: 'Rubik, sans-serif' }}>
                  <div style={{ background: '#1C2742', padding: '10px 14px', color: '#fff', fontSize: '14px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    {getSubscirbePriceScreenTopicInfo('NORTH_AMERICA_APPLE')?.['topicData']?.['product_description'] ?? 'Apple'}
                  </div>
                  <div style={{ background: '#FEFDF0', padding: '12px 14px' }}>
                    <div style={{ fontSize: '10px', color: '#888', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '2px' }}>Origin</div>
                    <div style={{ fontSize: '13px', color: '#333', fontWeight: '500', marginBottom: '8px' }}>
                      {getSubscirbePriceScreenTopicInfo('NORTH_AMERICA_APPLE')?.['topicData']?.['origin'] ?? 'Spain'}
                    </div>
                    <div style={{ fontSize: '11px', color: '#666', lineHeight: '1.5', marginBottom: '14px', minHeight: '48px' }}>
                      {getSubscirbePriceScreenTopicInfo('NORTH_AMERICA_APPLE')?.['topicData']?.['specification'] ?? 'Organic apples hand picked in Spain from sustainable farming. Package of 6'}
                    </div>
                    <div style={{ fontSize: '30px', fontWeight: '900', fontFamily: "'Impact', 'Arial Black', sans-serif", color: '#c0392b', letterSpacing: '-1px' }}>
                      {getSubscribeScreenPriceFormat('NORTH_AMERICA_APPLE') ?? '—'}
                    </div>
                  </div>
                  <div style={{ background: '#f8f8f8', borderTop: '1px solid #eee', padding: '8px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: '10px', fontFamily: 'monospace', color: '#888', letterSpacing: '1px' }}>
                      {getSubscirbePriceScreenTopicInfo('NORTH_AMERICA_APPLE')?.['topicData']?.['product_id'] ?? '002335'}
                    </span>
                    <img src={barcodeImage} style={{ width: '80px', height: '26px', objectFit: 'fill', opacity: 0.7 }} alt="" />
                  </div>
                </div>
              </div>
            </div>

          </div >
          <div className={classes.subscriberPriceBox}>
            <div
              className={classes.subscriberPriceHeader}
              style={{ background: '#1a3a8f' }}
            >EMEA</div>

            <div className={classes.subscriberPriceContent}>
              <div className={classes.addSubscriberTopic}>

                <TextField
                  id="outlined-error-helper-text"
                  label="Topic"
                  value={(() => {
                    let topicInfo = props.subscribePriceScreenData?.filter((t: any) => t['id'] === 'EMEA_BELGIAN_COCHOLATE')?.[0];
                    return topicInfo?.['topic'] ? topicInfo?.['topic'] : ''
                  })()}
                  onChange={(
                    event: React.ChangeEvent<
                      HTMLInputElement | HTMLTextAreaElement
                    >
                  ) => handleChangeSubscribePriceScreenTopic(event, 'EMEA_BELGIAN_COCHOLATE')}
                // helperText="seperated by '/'e.g:'test/v1'"
                />
                <Button
                  style={{
                    border: '2px black solid'
                  }}
                  variant="contained"
                  onClick={() => handleSubscribePriceScreenTopic('EMEA_BELGIAN_COCHOLATE')}
                  disabled={
                    getSubscirbePriceScreenTopicInfo('EMEA_BELGIAN_COCHOLATE')?.['topic'].length > 0
                      ? false
                      : true
                  }
                >
                  Subscribe
                </Button>
              </div>
              <div className={classes.subscriberPriceInfo}>
                <div style={{ width: '100%', borderRadius: '8px', overflow: 'hidden', border: '1px solid #e0e0e0', boxShadow: '0 2px 12px rgba(0,0,0,0.08)', fontFamily: 'Rubik, sans-serif' }}>
                  <div style={{ background: '#1C2742', padding: '10px 14px', color: '#fff', fontSize: '14px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    {getSubscirbePriceScreenTopicInfo('EMEA_BELGIAN_COCHOLATE')?.['topicData']?.['product_description'] ?? 'Milk Chocolate'}
                  </div>
                  <div style={{ background: '#FEFDF0', padding: '12px 14px' }}>
                    <div style={{ fontSize: '10px', color: '#888', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '2px' }}>Origin</div>
                    <div style={{ fontSize: '13px', color: '#333', fontWeight: '500', marginBottom: '8px' }}>
                      {getSubscirbePriceScreenTopicInfo('EMEA_BELGIAN_COCHOLATE')?.['topicData']?.['origin'] ?? 'Belgium'}
                    </div>
                    <div style={{ fontSize: '11px', color: '#666', lineHeight: '1.5', marginBottom: '14px', minHeight: '48px' }}>
                      {getSubscirbePriceScreenTopicInfo('EMEA_BELGIAN_COCHOLATE')?.['topicData']?.['specification'] ?? 'Assorted Belgian Milk Chocolate Truffles. 300g'}
                    </div>
                    <div style={{ fontSize: '30px', fontWeight: '900', fontFamily: "'Impact', 'Arial Black', sans-serif", color: '#c0392b', letterSpacing: '-1px' }}>
                      {getSubscribeScreenPriceFormat('EMEA_BELGIAN_COCHOLATE') ?? '—'}
                    </div>
                  </div>
                  <div style={{ background: '#f8f8f8', borderTop: '1px solid #eee', padding: '8px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: '10px', fontFamily: 'monospace', color: '#888', letterSpacing: '1px' }}>
                      {getSubscirbePriceScreenTopicInfo('EMEA_BELGIAN_COCHOLATE')?.['topicData']?.['product_id'] ?? '002335'}
                    </span>
                    <img src={barcodeImage} style={{ width: '80px', height: '26px', objectFit: 'fill', opacity: 0.7 }} alt="" />
                  </div>
                </div>
              </div>
            </div>


            <div className={classes.subscriberPriceContent}>
              <div className={classes.addSubscriberTopic}>
                <TextField
                  id="outlined-error-helper-text"
                  label="Topic"
                  value={(() => {
                    let topicInfo = props.subscribePriceScreenData?.filter((t: any) => t['id'] === 'EMEA_BELGIAN_APPLE')?.[0];
                    return topicInfo?.['topic'] ? topicInfo?.['topic'] : ''
                  })()}
                  onChange={(
                    event: React.ChangeEvent<
                      HTMLInputElement | HTMLTextAreaElement
                    >
                  ) => handleChangeSubscribePriceScreenTopic(event, 'EMEA_BELGIAN_APPLE')}
                // helperText="seperated by '/'e.g:'test/v1'"
                />
                <Button
                  style={{
                    border: '2px black solid'
                  }}
                  variant="contained"
                  onClick={() => handleSubscribePriceScreenTopic('EMEA_BELGIAN_APPLE')}
                  disabled={
                    getSubscirbePriceScreenTopicInfo('EMEA_BELGIAN_APPLE')?.['topic'].length > 0
                      ? false
                      : true
                  }
                >
                  Subscribe
                </Button>
              </div>
              <div className={classes.subscriberPriceInfo}>
                <div style={{ width: '100%', borderRadius: '8px', overflow: 'hidden', border: '1px solid #e0e0e0', boxShadow: '0 2px 12px rgba(0,0,0,0.08)', fontFamily: 'Rubik, sans-serif' }}>
                  <div style={{ background: '#1C2742', padding: '10px 14px', color: '#fff', fontSize: '14px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    {getSubscirbePriceScreenTopicInfo('EMEA_BELGIAN_APPLE')?.['topicData']?.['product_description'] ?? 'Apple'}
                  </div>
                  <div style={{ background: '#FEFDF0', padding: '12px 14px' }}>
                    <div style={{ fontSize: '10px', color: '#888', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '2px' }}>Origin</div>
                    <div style={{ fontSize: '13px', color: '#333', fontWeight: '500', marginBottom: '8px' }}>
                      {getSubscirbePriceScreenTopicInfo('EMEA_BELGIAN_APPLE')?.['topicData']?.['origin'] ?? 'Spain'}
                    </div>
                    <div style={{ fontSize: '11px', color: '#666', lineHeight: '1.5', marginBottom: '14px', minHeight: '48px' }}>
                      {getSubscirbePriceScreenTopicInfo('EMEA_BELGIAN_APPLE')?.['topicData']?.['specification'] ?? 'Organic apples hand picked in Spain from sustainable farming. Package of 6'}
                    </div>
                    <div style={{ fontSize: '30px', fontWeight: '900', fontFamily: "'Impact', 'Arial Black', sans-serif", color: '#c0392b', letterSpacing: '-1px' }}>
                      {getSubscribeScreenPriceFormat('EMEA_BELGIAN_APPLE') ?? '—'}
                    </div>
                  </div>
                  <div style={{ background: '#f8f8f8', borderTop: '1px solid #eee', padding: '8px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: '10px', fontFamily: 'monospace', color: '#888', letterSpacing: '1px' }}>
                      {getSubscirbePriceScreenTopicInfo('EMEA_BELGIAN_APPLE')?.['topicData']?.['product_id'] ?? '002335'}
                    </span>
                    <img src={barcodeImage} style={{ width: '80px', height: '26px', objectFit: 'fill', opacity: 0.7 }} alt="" />
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div className={classes.subscriberPriceBox}>
            <div
              className={classes.subscriberPriceHeader}
              style={{ background: '#b03a2e' }}
            >APJ</div>

            <div className={classes.subscriberPriceContent}>
              <div className={classes.addSubscriberTopic}>
                <TextField
                  id="outlined-error-helper-text"
                  label="Topic"
                  value={(() => {
                    let topicInfo = props.subscribePriceScreenData?.filter((t: any) => t['id'] === 'APJ_BELGIAN_COCHOLATE')?.[0];
                    return topicInfo?.['topic'] ? topicInfo?.['topic'] : ''
                  })()}
                  onChange={(
                    event: React.ChangeEvent<
                      HTMLInputElement | HTMLTextAreaElement
                    >
                  ) => handleChangeSubscribePriceScreenTopic(event, 'APJ_BELGIAN_COCHOLATE')}
                // helperText="seperated by '/'e.g:'test/v1'"
                />
                <Button
                  style={{
                    border: '2px black solid'
                  }}
                  variant="contained"
                  onClick={() => handleSubscribePriceScreenTopic('APJ_BELGIAN_COCHOLATE')}
                  disabled={
                    getSubscirbePriceScreenTopicInfo('APJ_BELGIAN_COCHOLATE')?.['topic'].length > 0
                      ? false
                      : true
                  }
                >
                  Subscribe
                </Button>
              </div>
              <div className={classes.subscriberPriceInfo}>
                <div style={{ width: '100%', borderRadius: '8px', overflow: 'hidden', border: '1px solid #e0e0e0', boxShadow: '0 2px 12px rgba(0,0,0,0.08)', fontFamily: 'Rubik, sans-serif' }}>
                  <div style={{ background: '#1C2742', padding: '10px 14px', color: '#fff', fontSize: '14px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    {getSubscirbePriceScreenTopicInfo('APJ_BELGIAN_COCHOLATE')?.['topicData']?.['product_description'] ?? 'Milk Chocolate'}
                  </div>
                  <div style={{ background: '#FEFDF0', padding: '12px 14px' }}>
                    <div style={{ fontSize: '10px', color: '#888', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '2px' }}>Origin</div>
                    <div style={{ fontSize: '13px', color: '#333', fontWeight: '500', marginBottom: '8px' }}>
                      {getSubscirbePriceScreenTopicInfo('APJ_BELGIAN_COCHOLATE')?.['topicData']?.['origin'] ?? 'Belgium'}
                    </div>
                    <div style={{ fontSize: '11px', color: '#666', lineHeight: '1.5', marginBottom: '14px', minHeight: '48px' }}>
                      {getSubscirbePriceScreenTopicInfo('APJ_BELGIAN_COCHOLATE')?.['topicData']?.['specification'] ?? 'Assorted Belgian Milk Chocolate Truffles. 300g'}
                    </div>
                    <div style={{ fontSize: '30px', fontWeight: '900', fontFamily: "'Impact', 'Arial Black', sans-serif", color: '#c0392b', letterSpacing: '-1px' }}>
                      {getSubscribeScreenPriceFormat('APJ_BELGIAN_COCHOLATE') ?? '—'}
                    </div>
                  </div>
                  <div style={{ background: '#f8f8f8', borderTop: '1px solid #eee', padding: '8px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: '10px', fontFamily: 'monospace', color: '#888', letterSpacing: '1px' }}>
                      {getSubscirbePriceScreenTopicInfo('APJ_BELGIAN_COCHOLATE')?.['topicData']?.['product_id'] ?? '002335'}
                    </span>
                    <img src={barcodeImage} style={{ width: '80px', height: '26px', objectFit: 'fill', opacity: 0.7 }} alt="" />
                  </div>
                </div>
              </div>
            </div>


            <div className={classes.subscriberPriceContent}>
              <div className={classes.addSubscriberTopic}>
                <TextField
                  id="outlined-error-helper-text"
                  label="Topic"
                  value={(() => {
                    let topicInfo = props.subscribePriceScreenData?.filter((t: any) => t['id'] === 'APJ_AAPLE')?.[0];
                    return topicInfo?.['topic'] ? topicInfo?.['topic'] : ''
                  })()}
                  onChange={(
                    event: React.ChangeEvent<
                      HTMLInputElement | HTMLTextAreaElement
                    >
                  ) => handleChangeSubscribePriceScreenTopic(event, 'APJ_AAPLE')}
                // helperText="seperated by '/'e.g:'test/v1'"
                />
                <Button
                  style={{
                    border: '2px black solid'
                  }}
                  variant="contained"
                  onClick={() => handleSubscribePriceScreenTopic('APJ_AAPLE')}
                  disabled={
                    getSubscirbePriceScreenTopicInfo('APJ_AAPLE')?.['topic'].length > 0
                      ? false
                      : true
                  }
                >
                  Subscribe
                </Button>
              </div>
              <div className={classes.subscriberPriceInfo}>
                <div style={{ width: '100%', borderRadius: '8px', overflow: 'hidden', border: '1px solid #e0e0e0', boxShadow: '0 2px 12px rgba(0,0,0,0.08)', fontFamily: 'Rubik, sans-serif' }}>
                  <div style={{ background: '#1C2742', padding: '10px 14px', color: '#fff', fontSize: '14px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    {getSubscirbePriceScreenTopicInfo('APJ_AAPLE')?.['topicData']?.['product_description'] ?? 'Apple'}
                  </div>
                  <div style={{ background: '#FEFDF0', padding: '12px 14px' }}>
                    <div style={{ fontSize: '10px', color: '#888', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '2px' }}>Origin</div>
                    <div style={{ fontSize: '13px', color: '#333', fontWeight: '500', marginBottom: '8px' }}>
                      {getSubscirbePriceScreenTopicInfo('APJ_AAPLE')?.['topicData']?.['origin'] ?? 'Spain'}
                    </div>
                    <div style={{ fontSize: '11px', color: '#666', lineHeight: '1.5', marginBottom: '14px', minHeight: '48px' }}>
                      {getSubscirbePriceScreenTopicInfo('APJ_AAPLE')?.['topicData']?.['specification'] ?? 'Organic apples hand picked in Spain from sustainable farming. Package of 6'}
                    </div>
                    <div style={{ fontSize: '30px', fontWeight: '900', fontFamily: "'Impact', 'Arial Black', sans-serif", color: '#c0392b', letterSpacing: '-1px' }}>
                      {getSubscribeScreenPriceFormat('APJ_AAPLE') ?? '—'}
                    </div>
                  </div>
                  <div style={{ background: '#f8f8f8', borderTop: '1px solid #eee', padding: '8px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: '10px', fontFamily: 'monospace', color: '#888', letterSpacing: '1px' }}>
                      {getSubscirbePriceScreenTopicInfo('APJ_AAPLE')?.['topicData']?.['product_id'] ?? '002335'}
                    </span>
                    <img src={barcodeImage} style={{ width: '80px', height: '26px', objectFit: 'fill', opacity: 0.7 }} alt="" />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      )
    }
    if (pathname.includes("/pricesubscriber")) {
      return (
        <div
          style={{
            padding: "0 20px",
          }}
        >
          <div className={classes.mainSubscriber}>
            {numberOfTopicSubscribers.map(
              (
                subCom: { id: number; topic: string; topicData: any },
                index: number
              ) => {
                return (
                  <Card
                    key={index}
                    className={classes.subScribeTable}
                    elevation={6}
                  >
                    <CardContent>
                      <div className={classes.addSubscriberTopic}>
                        <TextField
                          style={{
                            width: '45%'
                          }}
                          id="outlined-error-helper-text"
                          label="Topic"
                          value={(() => {
                            console.log(props.subComs, subCom)
                            let topicInfo = props.subComs.filter((t: any) => t['id'] === subCom['id'])[0];
                            return topicInfo['topic'] ? topicInfo['topic'] : ''
                          })()}
                          onChange={(
                            event: React.ChangeEvent<
                              HTMLInputElement | HTMLTextAreaElement
                            >
                          ) => handleChangeTopic(event, subCom["id"])}
                        // helperText="seperated by '/'e.g:'test/v1'"
                        />
                        <Button
                          variant="contained"
                          onClick={() => handleSubscribeTopic(subCom["id"])}
                          disabled={
                            subCom["topic"] && subCom["topic"].length > 0
                              ? false
                              : true
                          }
                        >
                          Subscribe
                        </Button>
                      </div>
                      <div>
                        <TableContainer
                          component={Paper}
                          className={classes.table}
                        >
                          <Table aria-label="simple table">
                            <TableHead className={commonStyle.tableHeader}>
                              <TableRow>
                                <TableCell className={commonStyle.tableCell}>
                                  Country
                                </TableCell>
                                <TableCell className={commonStyle.tableCell}>
                                  Province
                                </TableCell>
                                <TableCell className={commonStyle.tableCell}>
                                  Region
                                </TableCell>
                                <TableCell className={commonStyle.tableCell}>
                                  Product Id
                                </TableCell>
                                <TableCell className={commonStyle.tableCell}>
                                  Product Description
                                </TableCell>
                                <TableCell className={commonStyle.tableCell}>
                                  Pricing
                                </TableCell>
                                <TableCell className={commonStyle.tableCell}>
                                  Timestamp
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody className={commonStyle.tableBody}>
                              {subCom["topicData"] &&
                                subCom["topicData"].length > 0 ? (
                                subCom["topicData"].map(
                                  (row: any, index: number) => (
                                    <TableRow
                                      style={
                                        index % 2
                                          ? {
                                            background: "#DFDFE2",
                                          }
                                          : {
                                            background: "white",
                                          }
                                      }
                                      key={row.product_id}
                                    >
                                      <TableCell>{row.country}</TableCell>
                                      <TableCell>{row.province}</TableCell>
                                      <TableCell>{row.region}</TableCell>
                                      <TableCell>{row.product_id}</TableCell>
                                      <TableCell>
                                        {row.product_description}
                                      </TableCell>
                                      <TableCell>{row.pricing}</TableCell>
                                      <TableCell>{row.date}</TableCell>
                                    </TableRow>
                                  )
                                )
                              ) : (
                                <TableRow>
                                  <TableCell
                                    colSpan={7}
                                    style={{
                                      textAlign: "center",
                                      padding: "2rem",
                                    }}
                                  >
                                    <DescriptionTwoTone fontSize="large" />
                                    <div>No Rows</div>
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        {/* <TablePagination
                        rowsPerPageOptions={[25, 50, 75]}
                        component="div"
                        count={
                          subCom["topicData"] &&
                          subCom["topicData"].length > 0
                            ? subCom["topicData"].length
                            : 0
                        }
                        rowsPerPage={subCom["rowsPerPage"]}
                        page={subCom["page"]}
                        onPageChange={(event: unknown, newPage: number) =>
                          handleChangePage(event, newPage, subCom["id"])
                        }
                        onRowsPerPageChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => handleChangeRowsPerPage(event, subCom["id"])}
                      /> */}
                      </div>
                    </CardContent>
                  </Card>
                );
              }
            )}
          </div>
        </div>
      )
    }
  }

  return (
    <div className={classes.root}>
      {componentBasedOnPath()}
    </div>
  );
};